import { ReactNode, useMemo } from 'react';
import { ThemeProvider as ThemeProviderBase } from 'styled-components';

import { theme as defaultTheme, ITheme } from '../../styles';

type NestedPartial<T> = T extends Record<string, any>
  ? {
      [key in keyof T]?: NestedPartial<T[key]>;
    }
  : T;

const copy = (a: any) => {
  if (Array.isArray(a)) {
    return [...a];
  }
  const res = {};
  Object.keys(a).forEach((k) => {
    if (typeof a[k] === 'object') {
      res[k] = copy(a[k]);
    } else {
      res[k] = a[k];
    }
  });
  return res;
};

const merge = (a: any, b: any) => {
  if (!a) {
    return b;
  }
  if (!b) {
    return a;
  }

  Object.keys(b).forEach((k) => {
    if (typeof b[k] === 'object' && !Array.isArray(b[k])) {
      a[k] = merge(a[k], b[k]);
    } else {
      a[k] = b[k];
    }
  });

  return a;
};

export const ThemeProvider = <T extends NestedPartial<ITheme>>({
  theme,
  children,
}: {
  theme?: T;
  children: ReactNode;
}) => {
  const mergedTheme = useMemo(() => {
    return merge(copy(defaultTheme), theme);
  }, [theme]);

  return <ThemeProviderBase theme={mergedTheme}>{children}</ThemeProviderBase>;
};
